// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.archives-teacher_route .container {\r\n  width: 100% !important;\r\n  margin: auto !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
